import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useAuth } from "../context/AuthContext";
import { useMessages } from "../context/MessagesContext";
import * as api from "../api";

function MonEspace() {
  // ✅ CORRECTION : updateProfile au lieu de updateUser
  const { user, updateProfile } = useAuth();
  const { favoris } = useMessages();
  const [activeTab, setActiveTab] = useState("overview");
  const [editMode, setEditMode] = useState(false);
  const [myAnnoncesData, setMyAnnoncesData] = useState([]);
  const [myRfqDemandes, setMyRfqDemandes] = useState([]);
  const [monAbonnement, setMonAbonnement] = useState(null);
  const [statsAvancees, setStatsAvancees] = useState(null);
  const [rfqReponse, setRfqReponse]       = useState("");
  const [rfqEnvoi, setRfqEnvoi]           = useState(false);
  const [rfqSentOk, setRfqSentOk]         = useState(false);
  const [rfqErreur, setRfqErreur]         = useState("");
  const [selectedRfq, setSelectedRfq] = useState(null);
  const [profileData, setProfileData] = useState({
    nom: user?.nom || "",
    prenom: user?.prenom || "",
    telephone: user?.telephone || "",
    email: user?.email || "",
    entreprise: user?.entreprise || "",
    site_web: user?.site_web || ""
  });
  const [saveNotif, setSaveNotif] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // États IA
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // ✅ Réinitialiser les données à chaque changement d'utilisateur
    setMyAnnoncesData([]);
    setMyRfqDemandes([]);
    setMonAbonnement(null);
    setStatsAvancees(null);

    if (user) {
      if (user.role === "exposant") {
        api.getMesAnnonces().then(res => {
          const data = res.data;
          if (Array.isArray(data)) {
            setMyAnnoncesData(data);
          } else {
            setMyAnnoncesData(data.annonces || []);
          }
        }).catch(() => {});
        api.getAllRFQ().then(res => setMyRfqDemandes(res.data)).catch(() => {});
        api.getMonAbonnement().then(res => setMonAbonnement(res.data)).catch(() => {});
        // Stats avancées pour exposants premium
        const planActif = user.plan && user.plan !== "gratuit";
        if (planActif) {
          api.getStatsExposant(user.id).then(res => setStatsAvancees(res.data)).catch(() => {});
        }
      } else if (user.role === "admin") {
        api.getMesRFQ().then(res => setMyRfqDemandes(res.data)).catch(() => {});
      } else if (user.role === "acheteur" || user.role === "user") {
        api.getMesRFQ().then(res => setMyRfqDemandes(res.data)).catch(() => {});
      }
    }
  }, [user]);

  // Polling notifications toutes les 30 secondes
  useEffect(() => {
    if (!user) return;
    const interval = setInterval(async () => {
      try {
        // Recharge les RFQ pour détecter nouvelles réponses
        if (user.role === "exposant") {
          const res = await api.getAllRFQ();
          setMyRfqDemandes(res.data);
          // Mettre à jour selectedRfq si ouvert
          setSelectedRfq(prev => {
            if (!prev) return prev;
            const updated = res.data.find(r => r.id === prev.id);
            return updated || prev;
          });
        } else {
          const res = await api.getMesRFQ();
          setMyRfqDemandes(res.data);
          // Mettre à jour selectedRfq si ouvert (pour voir les nouvelles réponses)
          setSelectedRfq(prev => {
            if (!prev) return prev;
            const updated = res.data.find(r => r.id === prev.id);
            return updated || prev;
          });
        }
      } catch (e) { /* silencieux */ }
    }, 30000);
    return () => clearInterval(interval);
  }, [user]);

  if (!user) {
    navigate("/connexion");
    return null;
  }

  const favoriteAnnonces = favoris || [];

  const getRoleColor = (role) => {
    if (role === "exposant") return "#0d9488";
    if (role === "admin") return "#dc2626";
    return "#6366f1";
  };

  // ✅ CORRECTION : utilise updateProfile
  const handleSaveProfile = async () => {
    try {
      await updateProfile(profileData);
      setEditMode(false);
      setSaveNotif(true);
      setTimeout(() => setSaveNotif(false), 3000);
    } catch (err) {
      console.error(err);
    }
  };

  const typeProduitLabel = {
    yacht: "Yacht / Bateau de luxe", bateau_moteur: "Bateau à moteur",
    voilier: "Voilier", equipement: "Équipement maritime",
    moteur: "Moteur marin", electronique: "Électronique marine",
    sport: "Sports nautiques", autre: "Autre"
  };

  const rfqTabLabel = user.role === "exposant" ? "Demandes reçues" : "Mes demandes";

  const sidebarItems = [
    { id: "overview", label: "Vue d'ensemble", icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" },
    { id: "profile", label: "Mon profil", icon: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" },
    ...(user.role === "exposant" ? [{ id: "annonces", label: "Mes annonces", icon: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" }] : []),
    { id: "favoris", label: "Mes favoris", icon: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" },
    { id: "rfq", label: rfqTabLabel, icon: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2", badge: myRfqDemandes.length > 0 ? myRfqDemandes.length : undefined },
    ...(user.role === "exposant" ? [{ id: "import", label: "🌐 Importer mon site", icon: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" }] : []),
  ];

  const currentLabel = sidebarItems.find(i => i.id === activeTab)?.label || "";

  const SidebarButton = ({ item }) => (
    <button onClick={() => { setActiveTab(item.id); setSidebarOpen(false); }}
      style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", padding: "12px 15px", border: "none", borderRadius: "8px", cursor: "pointer", textAlign: "left", fontSize: "14px", fontWeight: activeTab === item.id ? "600" : "400", backgroundColor: activeTab === item.id ? "#f0fdfa" : "transparent", color: activeTab === item.id ? "#0d9488" : "#374151", marginBottom: "4px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d={item.icon}/></svg>
        {item.label}
      </div>
      {item.badge && <span style={{ backgroundColor: "#0d9488", color: "white", padding: "1px 8px", borderRadius: "20px", fontSize: "11px", fontWeight: "700" }}>{item.badge}</span>}
    </button>
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navbar />

      {saveNotif && (
        <div style={{ position: "fixed", top: "20px", right: "20px", zIndex: 9999, backgroundColor: "#0d9488", color: "white", padding: "12px 20px", borderRadius: "10px", boxShadow: "0 4px 20px rgba(0,0,0,0.2)", fontSize: "14px", fontWeight: "600" }}>
          ✓ Profil sauvegardé !
        </div>
      )}

      {/* Modal détail RFQ */}
      {selectedRfq && (
        <div onClick={() => { setSelectedRfq(null); setRfqReponse(""); setRfqSentOk(false); setRfqErreur(""); }} style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
          <div onClick={e => e.stopPropagation()} style={{ backgroundColor: "white", borderRadius: "16px", padding: "30px", maxWidth: "520px", width: "100%", maxHeight: "85vh", overflowY: "auto" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
              <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#1f2937" }}>
                {user.role === "exposant" ? "Détail de la demande reçue" : "Détail de ma demande"}
              </h3>
              <span style={{ fontSize: "12px", color: "#9ca3af", backgroundColor: "#f9fafb", padding: "4px 10px", borderRadius: "6px" }}>
                Réf. #{String(selectedRfq.id).slice(-6)}
              </span>
            </div>

            {/* Exposant voit les infos du demandeur */}
            {user.role === "exposant" && (
              <div style={{ backgroundColor: "#f9fafb", borderRadius: "10px", padding: "16px", marginBottom: "16px" }}>
                <p style={{ fontSize: "11px", color: "#9ca3af", fontWeight: "700", textTransform: "uppercase", marginBottom: "10px" }}>Informations du demandeur</p>
                {[
                  { label: "Nom", value: selectedRfq.nom },
                  { label: "Email", value: selectedRfq.email },
                  { label: "Téléphone", value: selectedRfq.telephone },
                ].map(f => f.value && (
                  <div key={f.label} style={{ display: "flex", gap: "12px", marginBottom: "6px" }}>
                    <span style={{ fontSize: "13px", color: "#9ca3af", minWidth: "80px", fontWeight: "500" }}>{f.label}</span>
                    <span style={{ fontSize: "13px", color: "#1f2937", fontWeight: "600" }}>{f.value}</span>
                  </div>
                ))}
              </div>
            )}

            {/* Détails communs */}
            <div style={{ backgroundColor: "#f0fdfa", borderRadius: "10px", padding: "16px", marginBottom: "16px" }}>
              <p style={{ fontSize: "11px", color: "#0d9488", fontWeight: "700", textTransform: "uppercase", marginBottom: "10px" }}>Détails de la demande</p>
              {[
                { label: "Type de produit", value: typeProduitLabel[selectedRfq.type_produit] || selectedRfq.type_produit },
                { label: "Quantité", value: selectedRfq.quantite },
                { label: "Annonce liée", value: selectedRfq.annonce_nom },
                { label: "Date limite", value: selectedRfq.date_limite ? new Date(selectedRfq.date_limite).toLocaleDateString("fr-FR") : null },
              ].map(f => f.value && (
                <div key={f.label} style={{ display: "flex", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "13px", color: "#6b7280", minWidth: "110px", fontWeight: "500" }}>{f.label}</span>
                  <span style={{ fontSize: "13px", color: "#1f2937", fontWeight: "600" }}>{f.value}</span>
                </div>
              ))}
            </div>

            {selectedRfq.besoin && (
              <div style={{ marginBottom: "12px" }}>
                <p style={{ fontSize: "11px", color: "#9ca3af", fontWeight: "700", textTransform: "uppercase", marginBottom: "6px" }}>Besoin</p>
                <p style={{ fontSize: "14px", color: "#374151", lineHeight: "1.6", backgroundColor: "#f9fafb", padding: "12px", borderRadius: "8px" }}>{selectedRfq.besoin}</p>
              </div>
            )}
            {selectedRfq.projet && (
              <div style={{ marginBottom: "12px" }}>
                <p style={{ fontSize: "11px", color: "#9ca3af", fontWeight: "700", textTransform: "uppercase", marginBottom: "6px" }}>Projet</p>
                <p style={{ fontSize: "14px", color: "#374151", lineHeight: "1.6", backgroundColor: "#f9fafb", padding: "12px", borderRadius: "8px" }}>{selectedRfq.projet}</p>
              </div>
            )}
            {selectedRfq.details && (
              <div style={{ marginBottom: "12px" }}>
                <p style={{ fontSize: "11px", color: "#9ca3af", fontWeight: "700", textTransform: "uppercase", marginBottom: "6px" }}>Détails supplémentaires</p>
                <p style={{ fontSize: "14px", color: "#374151", lineHeight: "1.6", backgroundColor: "#f9fafb", padding: "12px", borderRadius: "8px" }}>{selectedRfq.details}</p>
              </div>
            )}


            {/* Réponses reçues — acheteur seulement */}
            {user.role !== "exposant" && selectedRfq.reponses && selectedRfq.reponses.length > 0 && (
              <div style={{ marginTop: "16px" }}>
                <p style={{ fontSize: "11px", color: "#9ca3af", fontWeight: "700", textTransform: "uppercase", marginBottom: "10px" }}>
                  Réponses reçues ({selectedRfq.reponses.length})
                </p>
                {selectedRfq.reponses.map((r, i) => (
                  <div key={i} style={{ backgroundColor: "#f0fdfa", border: "1px solid #99f6e4", borderRadius: "10px", padding: "14px 16px", marginBottom: "10px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                      <span style={{ fontSize: "13px", fontWeight: "700", color: "#0f766e" }}>
                        ⭐ {r.auteur_nom}
                      </span>
                      <span style={{ fontSize: "11px", color: "#9ca3af" }}>
                        {r.created_at ? new Date(r.created_at).toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" }) : ""}
                      </span>
                    </div>
                    <p style={{ fontSize: "14px", color: "#374151", lineHeight: "1.6", margin: 0, whiteSpace: "pre-wrap" }}>{r.contenu}</p>
                  </div>
                ))}
              </div>
            )}

            {/* Aucune réponse encore — acheteur */}
            {user.role !== "exposant" && (!selectedRfq.reponses || selectedRfq.reponses.length === 0) && (
              <div style={{ marginTop: "16px", backgroundColor: "#fffbeb", border: "1px solid #fde68a", borderRadius: "10px", padding: "14px 16px", display: "flex", gap: "10px", alignItems: "center" }}>
                <span style={{ fontSize: "18px" }}>⏳</span>
                <p style={{ margin: 0, fontSize: "13px", color: "#92400e" }}>
                  Aucune réponse pour l'instant. Les exposants vous contacteront sous 48h.
                </p>
              </div>
            )}

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "16px", paddingTop: "16px", borderTop: "1px solid #f3f4f6" }}>
              <span style={{ fontSize: "12px", color: "#9ca3af" }}>
                Soumise le {selectedRfq.created_at ? new Date(selectedRfq.created_at).toLocaleDateString("fr-FR") : "—"}
              </span>
              <button onClick={() => { setSelectedRfq(null); setRfqReponse(""); setRfqSentOk(false); setRfqErreur(""); }} style={{ padding: "10px 24px", backgroundColor: "#0d9488", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: "600", fontSize: "14px" }}>
                Fermer
              </button>
            </div>

            {/* Réponses déjà envoyées — exposant */}
            {user.role === "exposant" && selectedRfq.reponses && selectedRfq.reponses.length > 0 && (
              <div style={{ marginTop: "16px" }}>
                <p style={{ fontSize: "11px", color: "#9ca3af", fontWeight: "700", textTransform: "uppercase", marginBottom: "10px" }}>
                  Réponses envoyées ({selectedRfq.reponses.length})
                </p>
                {selectedRfq.reponses.map((r, i) => (
                  <div key={i} style={{ backgroundColor: "#f0fdfa", border: "1px solid #99f6e4", borderRadius: "10px", padding: "14px 16px", marginBottom: "10px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                      <span style={{ fontSize: "13px", fontWeight: "700", color: "#0f766e" }}>✅ {r.auteur_nom}</span>
                      <span style={{ fontSize: "11px", color: "#9ca3af" }}>
                        {r.created_at ? new Date(r.created_at).toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" }) : ""}
                      </span>
                    </div>
                    <p style={{ fontSize: "14px", color: "#374151", lineHeight: "1.6", margin: 0, whiteSpace: "pre-wrap" }}>{r.contenu}</p>
                  </div>
                ))}
              </div>
            )}

            {/* Zone réponse — exposant seulement */}
            {user.role === "exposant" && (
              <div style={{ marginTop: "20px", borderTop: "1px solid #f3f4f6", paddingTop: "20px" }}>
                {rfqSentOk ? (
                  <div style={{ backgroundColor: "#f0fdf4", border: "1px solid #86efac", borderRadius: "10px", padding: "14px 16px", display: "flex", gap: 10, alignItems: "center" }}>
                    <span style={{ fontSize: 20 }}>✅</span>
                    <p style={{ margin: 0, color: "#16a34a", fontSize: 13, fontWeight: 600 }}>
                      Réponse envoyée par email à {selectedRfq.email}
                    </p>
                  </div>
                ) : (
                  <>
                    <label style={{ display: "block", fontSize: "13px", fontWeight: "700", color: "#374151", marginBottom: "8px" }}>
                      ✍️ Répondre à {selectedRfq.nom} <span style={{ color: "#9ca3af", fontWeight: 400 }}>({selectedRfq.email})</span>
                    </label>
                    <textarea
                      value={rfqReponse}
                      onChange={e => setRfqReponse(e.target.value)}
                      placeholder="Rédigez votre réponse : disponibilité, prix, délais..."
                      rows={4}
                      style={{ width: "100%", padding: "10px 12px", border: "1px solid #d1d5db", borderRadius: "8px", fontSize: "13px", boxSizing: "border-box", resize: "vertical", lineHeight: 1.6 }}
                    />
                    {rfqErreur && <p style={{ color: "#dc2626", fontSize: 12, marginTop: 6 }}>⚠️ {rfqErreur}</p>}
                    <button
                      onClick={async () => {
                        if (!rfqReponse.trim()) return;
                        setRfqEnvoi(true); setRfqErreur("");
                        try {
                          await api.repondreRFQ({ rfqId: selectedRfq.id, reponse: rfqReponse });
                          setRfqSentOk(true);
                          setRfqReponse("");
                          const res = await api.getAllRFQ();
                          setMyRfqDemandes(res.data);
                          // Mettre à jour selectedRfq pour afficher la réponse envoyée
                          const updatedRfq = res.data.find(r => r.id === selectedRfq.id);
                          if (updatedRfq) setSelectedRfq(updatedRfq);
                        } catch (err) {
                          setRfqErreur(err.response?.data?.message || "Erreur lors de l'envoi.");
                        } finally {
                          setRfqEnvoi(false);
                        }
                      }}
                      disabled={rfqEnvoi || !rfqReponse.trim()}
                      style={{ marginTop: "10px", padding: "10px 22px", background: rfqEnvoi || !rfqReponse.trim() ? "#9ca3af" : "#0d9488", color: "white", border: "none", borderRadius: "8px", fontWeight: 700, fontSize: 13, cursor: rfqEnvoi || !rfqReponse.trim() ? "not-allowed" : "pointer" }}>
                      {rfqEnvoi ? "Envoi..." : "📧 Envoyer la réponse"}
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      <div style={{ flex: 1, backgroundColor: "#f9fafb", padding: isMobile ? "16px" : "30px 50px" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto", display: "grid", gridTemplateColumns: isMobile ? "1fr" : "260px 1fr", gap: "30px" }}>

          {/* Sidebar */}
          <aside>
            <div style={{ backgroundColor: "white", borderRadius: "16px", padding: "24px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", marginBottom: "20px", textAlign: "center" }}>
              <div style={{ width: "72px", height: "72px", borderRadius: "50%", margin: "0 auto 12px", backgroundColor: getRoleColor(user.role), display: "flex", alignItems: "center", justifyContent: "center", fontSize: "24px", fontWeight: "700", color: "white" }}>
                {user.prenom?.[0]}{user.nom?.[0]}
              </div>
              <h3 style={{ fontSize: "16px", fontWeight: "700", color: "#1f2937", marginBottom: "4px" }}>{user.prenom} {user.nom}</h3>
              <span style={{ display: "inline-block", padding: "3px 12px", borderRadius: "20px", backgroundColor: getRoleColor(user.role) + "20", color: getRoleColor(user.role), fontSize: "12px", fontWeight: "700", textTransform: "uppercase" }}>
                {user.role}
              </span>
              {user.entreprise && <p style={{ fontSize: "13px", color: "#6b7280", marginTop: "8px" }}>{user.entreprise}</p>}
              {user.role === "exposant" && user.abonnement_expire_le && (() => {
                const expiry = new Date(user.abonnement_expire_le);
                const now = new Date();
                const isActive = expiry > now;
                const daysLeft = Math.ceil((expiry - now) / (1000 * 60 * 60 * 24));
                return (
                  <div style={{ marginTop: "12px", backgroundColor: isActive ? "#f0fdfa" : "#fef2f2", border: `1px solid ${isActive ? "#99f6e4" : "#fecaca"}`, borderRadius: "8px", padding: "10px 12px" }}>
                    <div style={{ fontSize: "11px", fontWeight: "700", color: isActive ? "#0f766e" : "#dc2626", textTransform: "uppercase", marginBottom: "4px" }}>
                      {isActive ? "✅ Abonnement actif" : "❌ Abonnement expiré"}
                    </div>
                    <div style={{ fontSize: "12px", color: isActive ? "#0d9488" : "#dc2626" }}>
                      {isActive
                        ? `Expire le ${expiry.toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" })} (${daysLeft}j restants)`
                        : `Expiré le ${expiry.toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" })}`
                      }
                    </div>
                  </div>
                );
              })()}
            </div>

            {user.role === "acheteur" && (
              <Link to="/devenir-exposant" style={{ display: "block", backgroundColor: "#0d9488", color: "white", padding: "14px", borderRadius: "12px", textDecoration: "none", textAlign: "center", fontSize: "13px", fontWeight: "600", marginBottom: "20px" }}>
                ⭐ Devenir Exposant
              </Link>
            )}

            {isMobile ? (
              <div style={{ backgroundColor: "white", borderRadius: "12px", padding: "12px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", marginBottom: "8px" }}>
                <button onClick={() => setSidebarOpen(!sidebarOpen)} style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 15px", border: "none", borderRadius: "8px", cursor: "pointer", backgroundColor: "#f0fdfa", color: "#0d9488", fontSize: "14px", fontWeight: "600" }}>
                  <span>{currentLabel}</span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points={sidebarOpen ? "18 15 12 9 6 15" : "6 9 12 15 18 9"} />
                  </svg>
                </button>
                {sidebarOpen && <div style={{ marginTop: "8px" }}>{sidebarItems.map(item => <SidebarButton key={item.id} item={item} />)}</div>}
              </div>
            ) : (
              <div style={{ backgroundColor: "white", borderRadius: "16px", padding: "12px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
                {sidebarItems.map(item => <SidebarButton key={item.id} item={item} />)}
              </div>
            )}
          </aside>

          {/* Content */}
          <main>

            {/* Overview */}
            {activeTab === "overview" && (
              <div>
                <h2 style={{ fontSize: isMobile ? "20px" : "24px", fontWeight: "700", color: "#1f2937", marginBottom: "20px" }}>Bienvenue, {user.prenom} 👋</h2>
                <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)", gap: "20px", marginBottom: "30px" }}>
                  {[
                    { label: "Annonces publiées", value: user.role === "exposant" ? myAnnoncesData.length : "—", color: "#0d9488" },
                    { label: "Favoris", value: favoriteAnnonces.length, color: "#6366f1" },
                    { label: user.role === "exposant" ? "Demandes reçues" : "Mes demandes RFQ", value: myRfqDemandes.length, color: "#f59e0b" }
                  ].map(stat => (
                    <div key={stat.label} style={{ backgroundColor: "white", borderRadius: "12px", padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", textAlign: "center" }}>
                      <div style={{ fontSize: "36px", fontWeight: "700", color: stat.color }}>{stat.value}</div>
                      <div style={{ fontSize: "13px", color: "#6b7280", marginTop: "4px" }}>{stat.label}</div>
                    </div>
                  ))}
                </div>

                {user.role === "exposant" && (() => {
                  const plan = monAbonnement?.plan_actuel || user?.plan || "gratuit";
                  const expireRaw = monAbonnement?.expire_le || user?.abonnement_expire_le || null;
                  const isPaid = plan && plan !== "gratuit";
                  const expiry = expireRaw ? new Date(expireRaw) : null;
                  const isActive = expiry && expiry > new Date();
                  const daysLeft = isActive ? Math.ceil((expiry - new Date()) / (1000 * 60 * 60 * 24)) : 0;
                  const pendingDemande = monAbonnement?.historique?.find(h => h.statut === "PENDING");
                  const PLAN_LABELS = { premium_starter: "Premium Starter", premium_business: "Premium Business", premium_enterprise: "Enterprise", gratuit: "Gratuit" };

                  if (pendingDemande && !isActive) {
                    return (
                      <div style={{ backgroundColor: "#fffbeb", border: "1px solid #fde68a", borderRadius: "12px", padding: "18px 22px", marginBottom: "20px", display: "flex", gap: 14, alignItems: "center" }}>
                        <span style={{ fontSize: 28 }}>⏳</span>
                        <div>
                          <div style={{ fontWeight: 700, color: "#92400e", fontSize: 14 }}>Demande d'abonnement en cours de vérification</div>
                          <div style={{ fontSize: 13, color: "#b45309", marginTop: 3 }}>
                            Plan demandé : <strong>{PLAN_LABELS[pendingDemande.plan] || pendingDemande.plan}</strong>. L'admin va valider votre reçu sous 24–48h.
                          </div>
                        </div>
                      </div>
                    );
                  }

                  if (isPaid && isActive) {
                    return (
                      <div style={{ backgroundColor: "#f0fdf4", border: "2px solid #86efac", borderRadius: "12px", padding: "18px 22px", marginBottom: "20px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
                          <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                            <span style={{ fontSize: 28 }}>✅</span>
                            <div>
                              <div style={{ fontWeight: 800, color: "#15803d", fontSize: 15 }}>
                                Abonnement actif — {PLAN_LABELS[plan] || plan}
                              </div>
                              <div style={{ fontSize: 13, color: "#16a34a", marginTop: 3 }}>
                                Expire le <strong>{expiry.toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" })}</strong>
                                {" "}· {daysLeft} jour{daysLeft > 1 ? "s" : ""} restant{daysLeft > 1 ? "s" : ""}
                              </div>
                            </div>
                          </div>
                          <Link to="/abonnement" style={{ fontSize: 12, color: "#0d9488", textDecoration: "none", padding: "6px 14px", border: "1px solid #0d9488", borderRadius: 20, fontWeight: 600, whiteSpace: "nowrap" }}>
                            Renouveler →
                          </Link>
                        </div>
                        <div style={{ marginTop: 12, backgroundColor: "white", borderRadius: 6, overflow: "hidden", height: 6 }}>
                          <div style={{ height: "100%", backgroundColor: daysLeft > 20 ? "#22c55e" : daysLeft > 7 ? "#f59e0b" : "#dc2626", width: `${Math.min(100, (daysLeft / 30) * 100)}%`, transition: "width 0.3s" }} />
                        </div>
                      </div>
                    );
                  }

                  if (isPaid && !isActive) {
                    return (
                      <div style={{ backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "12px", padding: "18px 22px", marginBottom: "20px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
                        <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                          <span style={{ fontSize: 28 }}>❌</span>
                          <div>
                            <div style={{ fontWeight: 700, color: "#dc2626", fontSize: 14 }}>Abonnement expiré</div>
                            <div style={{ fontSize: 13, color: "#b91c1c", marginTop: 3 }}>
                              Votre abonnement {PLAN_LABELS[plan]} a expiré le {expiry?.toLocaleDateString("fr-FR") || "—"}.
                            </div>
                          </div>
                        </div>
                        <Link to="/abonnement" style={{ backgroundColor: "#dc2626", color: "white", padding: "9px 18px", borderRadius: 8, textDecoration: "none", fontSize: 13, fontWeight: 700 }}>
                          Renouveler
                        </Link>
                      </div>
                    );
                  }

                  // Plan gratuit
                  return (
                    <div style={{ backgroundColor: "#f8fafc", border: "1px dashed #cbd5e1", borderRadius: "12px", padding: "18px 22px", marginBottom: "20px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
                      <div>
                        <div style={{ fontWeight: 600, color: "#374151", fontSize: 14 }}>Plan actuel : Gratuit</div>
                        <div style={{ fontSize: 13, color: "#6b7280", marginTop: 3 }}>Passez à un plan premium pour plus de visibilité et d'annonces.</div>
                      </div>
                      <Link to="/abonnement" style={{ backgroundColor: "#0d9488", color: "white", padding: "9px 18px", borderRadius: 8, textDecoration: "none", fontSize: 13, fontWeight: 700 }}>
                        ⭐ Upgrader
                      </Link>
                    </div>
                  );
                })()}

                {user.role === "exposant" && statsAvancees && (
                  <div style={{ backgroundColor:"white", borderRadius:"12px", padding:"24px", boxShadow:"0 1px 3px rgba(0,0,0,0.1)", marginBottom:"20px" }}>
                    <h3 style={{ fontSize:"16px", fontWeight:"700", color:"#1f2937", marginBottom:"16px" }}>📊 Statistiques de performance</h3>
                    <div style={{ display:"grid", gridTemplateColumns: isMobile?"repeat(2,1fr)":"repeat(4,1fr)", gap:"14px", marginBottom:"16px" }}>
                      {[
                        { label:"Vues totales", value: statsAvancees.totalVues || 0, color:"#6366f1", icon:"👁" },
                        { label:"Favoris reçus", value: statsAvancees.totalFavoris || 0, color:"#ec4899", icon:"❤️" },
                        { label:"Messages reçus", value: statsAvancees.totalMessages || 0, color:"#0d9488", icon:"💬" },
                        { label:"Note moyenne", value: statsAvancees.noteMoyenne > 0 ? `${statsAvancees.noteMoyenne}/5` : "—", color:"#f59e0b", icon:"⭐" },
                      ].map(s => (
                        <div key={s.label} style={{ backgroundColor:"#f9fafb", borderRadius:"10px", padding:"14px", textAlign:"center" }}>
                          <div style={{ fontSize:"22px", marginBottom:"4px" }}>{s.icon}</div>
                          <div style={{ fontSize:"22px", fontWeight:"700", color:s.color }}>{s.value}</div>
                          <div style={{ fontSize:"12px", color:"#6b7280", marginTop:"2px" }}>{s.label}</div>
                        </div>
                      ))}
                    </div>
                    {statsAvancees.topAnnonces?.length > 0 && (
                      <div>
                        <p style={{ fontSize:"13px", fontWeight:"600", color:"#6b7280", marginBottom:"10px", textTransform:"uppercase" }}>Top annonces les plus vues</p>
                        {statsAvancees.topAnnonces.map((a, i) => (
                          <div key={i} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"8px 0", borderBottom: i < statsAvancees.topAnnonces.length-1 ? "1px solid #f3f4f6" : "none" }}>
                            <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
                              {a.image && <img src={a.image} alt="" style={{ width:"36px", height:"36px", objectFit:"cover", borderRadius:"6px" }} />}
                              <span style={{ fontSize:"13px", color:"#374151", fontWeight:"500" }}>{a.nom?.substring(0,40)}...</span>
                            </div>
                            <span style={{ fontSize:"13px", fontWeight:"700", color:"#6366f1" }}>👁 {a.vues}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                {user.role === "exposant" && (
                  <div style={{ backgroundColor: "white", borderRadius: "12px", padding: "24px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", marginBottom: "20px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                      <h3 style={{ fontSize: "16px", fontWeight: "600", color: "#1f2937" }}>Mes dernières annonces</h3>
                      <Link to="/mes-annonces" style={{ fontSize: "13px", color: "#0d9488", textDecoration: "none" }}>Voir tout →</Link>
                    </div>
                    {myAnnoncesData.length > 0 ? myAnnoncesData.slice(0, 3).map(annonce => (
                      <div key={annonce.id} style={{ display: "flex", alignItems: "center", gap: "12px", padding: "12px 0", borderBottom: "1px solid #f3f4f6" }}>
                        <img src={annonce.image} alt={annonce.nom} style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "8px", flexShrink: 0 }} />
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: "14px", fontWeight: "600", color: "#1f2937", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{annonce.nom}</div>
                          <div style={{ fontSize: "13px", color: "#0d9488" }}>{annonce.prix}</div>
                        </div>
                        <span style={{ padding: "3px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: "600", flexShrink: 0, backgroundColor: annonce.statut === "suspendue" ? "#fef2f2" : "#f0fdfa", color: annonce.statut === "suspendue" ? "#dc2626" : "#0d9488" }}>
                          {annonce.statut || "active"}
                        </span>
                      </div>
                    )) : (
                      <div style={{ textAlign: "center", padding: "30px" }}>
                        <p style={{ color: "#9ca3af", fontSize: "14px", marginBottom: "15px" }}>Aucune annonce pour l'instant.</p>
                        <Link to="/ajouter-annonce" style={{ display: "inline-flex", alignItems: "center", gap: "6px", backgroundColor: "#0d9488", color: "white", padding: "10px 18px", borderRadius: "8px", textDecoration: "none", fontSize: "13px", fontWeight: "600" }}>+ Publier une annonce</Link>
                      </div>
                    )}
                  </div>
                )}

                {myRfqDemandes.length > 0 && (
                  <div style={{ backgroundColor: "white", borderRadius: "12px", padding: "24px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                      <h3 style={{ fontSize: "16px", fontWeight: "600", color: "#1f2937" }}>
                        {user.role === "exposant" ? "Dernières demandes reçues" : "Mes dernières demandes RFQ"}
                      </h3>
                      <button onClick={() => setActiveTab("rfq")} style={{ fontSize: "13px", color: "#0d9488", background: "none", border: "none", cursor: "pointer" }}>Voir tout →</button>
                    </div>
                    {myRfqDemandes.slice(0, 2).map(d => (
                      <div key={d.id} style={{ display: "flex", alignItems: "center", gap: "12px", padding: "12px 0", borderBottom: "1px solid #f3f4f6" }}>
                        <div style={{ width: "40px", height: "40px", borderRadius: "10px", backgroundColor: "#f0fdfa", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0d9488" strokeWidth="2">
                            <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
                          </svg>
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: "14px", fontWeight: "600", color: "#1f2937" }}>
                            {user.role === "exposant" ? (d.nom || "Demandeur") : (typeProduitLabel[d.type_produit] || "Produits maritimes")}
                          </div>
                          <div style={{ fontSize: "12px", color: "#9ca3af" }}>{d.created_at ? new Date(d.created_at).toLocaleDateString("fr-FR") : ""}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* Profile */}
            {activeTab === "profile" && (
              <div style={{ backgroundColor: "white", borderRadius: "16px", padding: isMobile ? "20px 16px" : "30px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
                  <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#1f2937" }}>Mon profil</h2>
                  <button onClick={() => editMode ? handleSaveProfile() : setEditMode(true)} style={{ padding: "10px 20px", backgroundColor: editMode ? "#0d9488" : "white", color: editMode ? "white" : "#374151", border: "1px solid #e5e7eb", borderRadius: "8px", cursor: "pointer", fontSize: "14px", fontWeight: "600" }}>
                    {editMode ? "Sauvegarder" : "Modifier"}
                  </button>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: "20px" }}>
                  {[{ label: "Nom", key: "nom" }, { label: "Prénom", key: "prenom" }, { label: "Email", key: "email" }, { label: "Téléphone", key: "telephone" }].map(field => (
                    <div key={field.key}>
                      <label style={{ display: "block", fontSize: "13px", color: "#6b7280", marginBottom: "6px", fontWeight: "500" }}>{field.label}</label>
                      {editMode ? (
                        <input type="text" value={profileData[field.key]} onChange={e => setProfileData(prev => ({ ...prev, [field.key]: e.target.value }))} style={{ width: "100%", padding: "10px 12px", border: "1px solid #0d9488", borderRadius: "8px", fontSize: "14px", outline: "none", boxSizing: "border-box" }} />
                      ) : (
                        <div style={{ padding: "10px 0", fontSize: "15px", fontWeight: "500", color: "#1f2937", borderBottom: "1px solid #f3f4f6" }}>{profileData[field.key] || "—"}</div>
                      )}
                    </div>
                  ))}
                  {/* ✅ Champs entreprise et site web pour exposant */}
                  {user.role === "exposant" && (
                    <>
                      <div>
                        <label style={{ display: "block", fontSize: "13px", color: "#6b7280", marginBottom: "6px", fontWeight: "500" }}>Nom de l'entreprise</label>
                        {editMode ? (
                          <input type="text" value={profileData.entreprise} onChange={e => setProfileData(prev => ({ ...prev, entreprise: e.target.value }))} placeholder="Ex: Marine Pro DZ" style={{ width: "100%", padding: "10px 12px", border: "1px solid #0d9488", borderRadius: "8px", fontSize: "14px", outline: "none", boxSizing: "border-box" }} />
                        ) : (
                          <div style={{ padding: "10px 0", fontSize: "15px", fontWeight: "500", color: "#1f2937", borderBottom: "1px solid #f3f4f6" }}>{profileData.entreprise || "—"}</div>
                        )}
                      </div>
                      <div>
                        <label style={{ display: "block", fontSize: "13px", color: "#6b7280", marginBottom: "6px", fontWeight: "500" }}>Site web de l'entreprise</label>
                        {editMode ? (
                          <input type="text" value={profileData.site_web} onChange={e => setProfileData(prev => ({ ...prev, site_web: e.target.value }))} placeholder="Ex: www.marineprodz.com" style={{ width: "100%", padding: "10px 12px", border: "1px solid #0d9488", borderRadius: "8px", fontSize: "14px", outline: "none", boxSizing: "border-box" }} />
                        ) : (
                          <div style={{ padding: "10px 0", fontSize: "15px", fontWeight: "500", color: "#1f2937", borderBottom: "1px solid #f3f4f6" }}>
                            {profileData.site_web ? (
                              <a href={profileData.site_web.startsWith("http") ? profileData.site_web : `https://${profileData.site_web}`} target="_blank" rel="noreferrer" style={{ color: "#0d9488", textDecoration: "none" }}>
                                🌐 {profileData.site_web}
                              </a>
                            ) : "—"}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
                {editMode && (
                  <button onClick={() => setEditMode(false)} style={{ marginTop: "16px", padding: "10px 20px", backgroundColor: "white", color: "#6b7280", border: "1px solid #e5e7eb", borderRadius: "8px", cursor: "pointer", fontSize: "14px" }}>Annuler</button>
                )}
                <div style={{ marginTop: "24px", padding: "16px", backgroundColor: "#f9fafb", borderRadius: "8px" }}>
                  <div style={{ fontSize: "13px", color: "#6b7280", marginBottom: "4px" }}>Membre depuis</div>
                  <div style={{ fontSize: "15px", fontWeight: "600", color: "#1f2937" }}>{user.created_at ? new Date(user.created_at).toLocaleDateString("fr-FR") : "—"}</div>
                </div>
                {user.role === "exposant" && (() => {
                  const aboExpire = monAbonnement?.expire_le || user.abonnement_expire_le;
                  const aboActif = monAbonnement?.historique?.find(h => h.statut === "ACTIVE") || (aboExpire && new Date(aboExpire) > new Date());
                  return (
                  <div style={{ marginTop: "16px", padding: "20px", backgroundColor: aboActif ? "#f0fdfa" : "#fef2f2", border: `1px solid ${aboActif ? "#99f6e4" : "#fecaca"}`, borderRadius: "10px" }}>
                    <h4 style={{ fontSize: "14px", fontWeight: "700", color: aboActif ? "#0f766e" : "#dc2626", marginBottom: "12px" }}>
                      {aboActif ? "✅ Abonnement Exposant — Actif" : "❌ Abonnement Exposant — Expiré ou non défini"}
                    </h4>
                    {aboExpire ? (() => {
                      const expiry = new Date(aboExpire);
                      const now = new Date();
                      const isActive = expiry > now;
                      const daysLeft = Math.ceil((expiry - now) / (1000 * 60 * 60 * 24));
                      return (
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
                          <div>
                            <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "3px" }}>Statut</div>
                            <div style={{ fontSize: "14px", fontWeight: "700", color: isActive ? "#0d9488" : "#dc2626" }}>{isActive ? "Actif" : "Expiré"}</div>
                          </div>
                          <div>
                            <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "3px" }}>Date d'expiration</div>
                            <div style={{ fontSize: "14px", fontWeight: "600", color: "#1f2937" }}>{expiry.toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" })}</div>
                          </div>
                          {isActive && (
                            <div style={{ gridColumn: "1 / -1" }}>
                              <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "6px" }}>Temps restant</div>
                              <div style={{ backgroundColor: "white", borderRadius: "6px", overflow: "hidden", height: "8px" }}>
                                <div style={{ height: "100%", backgroundColor: daysLeft > 90 ? "#0d9488" : daysLeft > 30 ? "#f59e0b" : "#dc2626", width: `${Math.min(100, (daysLeft / 365) * 100)}%`, transition: "width 0.3s" }} />
                              </div>
                              <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "4px" }}>{daysLeft} jour{daysLeft > 1 ? "s" : ""} restant{daysLeft > 1 ? "s" : ""}</div>
                            </div>
                          )}
                        </div>
                      );
                    })() : (
                      <p style={{ fontSize: "13px", color: "#9ca3af" }}>Aucune date d'expiration enregistrée.</p>
                    )}
                  </div>
                  );
                })()}
              </div>
            )}

            {/* Annonces (exposant) */}
            {activeTab === "annonces" && user.role === "exposant" && (
              <div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", flexWrap: "wrap", gap: "10px" }}>
                  <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#1f2937" }}>Mes annonces</h2>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <Link to="/mes-annonces" style={{ backgroundColor: "white", color: "#374151", padding: "10px 18px", borderRadius: "8px", textDecoration: "none", fontSize: "14px", fontWeight: "600", border: "1px solid #e5e7eb" }}>Gérer</Link>
                    <Link to="/ajouter-annonce" style={{ backgroundColor: "#0d9488", color: "white", padding: "10px 18px", borderRadius: "8px", textDecoration: "none", fontSize: "14px", fontWeight: "600" }}>+ Nouvelle</Link>
                  </div>
                </div>
                {myAnnoncesData.length > 0 ? (
                  <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                    {myAnnoncesData.map(annonce => (
                      <div key={annonce.id} style={{ backgroundColor: "white", borderRadius: "12px", padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", display: "flex", alignItems: "center", gap: "15px", flexWrap: "wrap" }}>
                        <img src={annonce.image} alt={annonce.nom} style={{ width: "80px", height: "60px", objectFit: "cover", borderRadius: "8px" }} />
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: "15px", fontWeight: "600", color: "#1f2937" }}>{annonce.nom}</div>
                          <div style={{ fontSize: "14px", color: "#0d9488", fontWeight: "700" }}>{annonce.prix}</div>
                        </div>
                        <span style={{ padding: "4px 12px", borderRadius: "20px", fontSize: "12px", fontWeight: "600", backgroundColor: "#f0fdfa", color: "#0d9488" }}>{annonce.statut || "active"}</span>
                        <div style={{ display: "flex", gap: "8px" }}>
                          <Link to={`/annonce/${annonce.id}`} style={{ padding: "7px 14px", backgroundColor: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "6px", textDecoration: "none", color: "#374151", fontSize: "13px" }}>Voir</Link>
                          <Link to={`/modifier-annonce/${annonce.id}`} style={{ padding: "7px 14px", backgroundColor: "#f0fdfa", border: "1px solid #0d9488", borderRadius: "6px", textDecoration: "none", color: "#0d9488", fontSize: "13px", fontWeight: "600" }}>Modifier</Link>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div style={{ textAlign: "center", padding: "60px", backgroundColor: "white", borderRadius: "16px" }}>
                    <p style={{ color: "#9ca3af", marginBottom: "20px" }}>Vous n'avez pas encore d'annonces.</p>
                    <Link to="/ajouter-annonce" style={{ backgroundColor: "#0d9488", color: "white", padding: "12px 24px", borderRadius: "8px", textDecoration: "none", fontWeight: "600" }}>Publier ma première annonce</Link>
                  </div>
                )}
              </div>
            )}

            {/* Favoris */}
            {activeTab === "favoris" && (
              <div>
                <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#1f2937", marginBottom: "20px" }}>Mes favoris</h2>
                {favoriteAnnonces.length > 0 ? (
                  <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(2, 1fr)", gap: "20px" }}>
                    {favoriteAnnonces.map(annonce => (
                      <Link key={annonce.id} to={`/annonce/${annonce.id}`} style={{ textDecoration: "none", backgroundColor: "white", borderRadius: "12px", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", border: "1px solid #e5e7eb" }}>
                        <img src={annonce.image} alt={annonce.nom} style={{ width: "100%", height: "160px", objectFit: "cover" }} />
                        <div style={{ padding: "16px" }}>
                          <div style={{ fontSize: "15px", fontWeight: "600", color: "#1f2937", marginBottom: "6px" }}>{annonce.nom}</div>
                          <div style={{ fontSize: "17px", fontWeight: "700", color: "#0d9488" }}>{annonce.prix}</div>
                        </div>
                      </Link>
                    ))}
                  </div>
                ) : (
                  <div style={{ textAlign: "center", padding: "60px", backgroundColor: "white", borderRadius: "16px" }}>
                    <p style={{ color: "#9ca3af", marginBottom: "16px" }}>Vous n'avez pas encore de favoris.</p>
                    <Link to="/catalogue" style={{ color: "#0d9488", textDecoration: "none", fontWeight: "600" }}>Explorer le catalogue →</Link>
                  </div>
                )}
              </div>
            )}

            {/* RFQ */}
            {activeTab === "rfq" && (
              <div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", flexWrap: "wrap", gap: "10px" }}>
                  <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#1f2937" }}>
                    {user.role === "exposant" ? "Demandes de devis reçues" : "Mes demandes de devis"}
                  </h2>
                  {user.role === "acheteur" && (
                    <Link to="/rfq" style={{ display: "flex", alignItems: "center", gap: "8px", backgroundColor: "#0d9488", color: "white", padding: "10px 20px", borderRadius: "8px", textDecoration: "none", fontSize: "14px", fontWeight: "600" }}>
                      + Nouvelle demande
                    </Link>
                  )}
                </div>

                {myRfqDemandes.length > 0 ? (
                  <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
                    {myRfqDemandes.map(demande => (
                      <div key={demande.id} style={{
                        backgroundColor: "white", borderRadius: "14px", padding: isMobile ? "16px" : "22px",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                        border: demande.statut === "traite" ? "2px solid #86efac" : "1px solid #f3f4f6"
                      }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "14px", flexWrap: "wrap", gap: "8px" }}>
                          <div>
                            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                              <h3 style={{ fontSize: "15px", fontWeight: "700", color: "#1f2937", margin: 0 }}>
                                {user.role === "exposant"
                                  ? (demande.nom || "Demandeur anonyme")
                                  : (typeProduitLabel[demande.type_produit] || "Produits maritimes")
                                }
                              </h3>
                              {/* Badge statut pour acheteur */}
                              {user.role !== "exposant" && demande.statut === "traite" && (
                                <span style={{ fontSize: 11, fontWeight: 700, background: "#f0fdf4", color: "#16a34a", border: "1px solid #86efac", padding: "2px 10px", borderRadius: 20 }}>
                                  ✅ Réponse reçue
                                </span>
                              )}
                              {user.role !== "exposant" && demande.statut !== "traite" && (
                                <span style={{ fontSize: 11, fontWeight: 700, background: "#fffbeb", color: "#b45309", border: "1px solid #fde68a", padding: "2px 10px", borderRadius: 20 }}>
                                  ⏳ En attente
                                </span>
                              )}
                            </div>
                            {user.role === "exposant" && demande.type_produit && (
                              <p style={{ fontSize: "13px", color: "#0d9488", marginBottom: "2px" }}>
                                {typeProduitLabel[demande.type_produit] || demande.type_produit}
                              </p>
                            )}
                            {demande.annonce_nom && (
                              <p style={{ fontSize: "12px", color: "#6b7280" }}>Annonce : {demande.annonce_nom}</p>
                            )}
                            <p style={{ fontSize: "12px", color: "#9ca3af", marginTop: "2px" }}>
                              Soumise le {demande.created_at ? new Date(demande.created_at).toLocaleDateString("fr-FR") : "—"}
                            </p>
                          </div>
                          <span style={{ fontSize: "12px", color: "#6b7280", backgroundColor: "#f9fafb", padding: "4px 10px", borderRadius: "6px" }}>
                            Réf. #{String(demande.id).slice(-6)}
                          </span>
                        </div>

                        {demande.besoin && (
                          <div style={{ backgroundColor: "#f9fafb", borderRadius: "8px", padding: "12px", marginBottom: "10px" }}>
                            <p style={{ fontSize: "12px", color: "#9ca3af", marginBottom: "4px", fontWeight: "600", textTransform: "uppercase" }}>Besoin</p>
                            <p style={{ fontSize: "14px", color: "#374151", lineHeight: "1.5" }}>
                              {demande.besoin.length > 120 ? demande.besoin.slice(0, 120) + "..." : demande.besoin}
                            </p>
                          </div>
                        )}

                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                          <button onClick={async () => {
  // Charger les réponses fraîches depuis l'API au moment du clic
  let rfqAvecReponses = { ...demande };
  try {
    const res = await api.getReponsesRFQ(demande.id);
    rfqAvecReponses.reponses = res.data;
  } catch (e) {
    rfqAvecReponses.reponses = [];
  }
  setSelectedRfq(rfqAvecReponses);
}} style={{ padding: "8px 16px", backgroundColor: "#f0fdfa", color: "#0d9488", border: "1px solid #0d9488", borderRadius: "8px", cursor: "pointer", fontSize: "13px", fontWeight: "600" }}>
  Voir détails →
</button>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div style={{ textAlign: "center", padding: "60px", backgroundColor: "white", borderRadius: "16px" }}>
                    <div style={{ width: "60px", height: "60px", borderRadius: "50%", backgroundColor: "#f0fdfa", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#0d9488" strokeWidth="1.5">
                        <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
                      </svg>
                    </div>
                    <p style={{ color: "#9ca3af", marginBottom: "16px" }}>
                      {user.role === "exposant" ? "Aucune demande reçue pour l'instant." : "Aucune demande de devis pour l'instant."}
                    </p>
                    {user.role === "acheteur" && (
                      <Link to="/rfq" style={{ display: "inline-flex", alignItems: "center", gap: "8px", backgroundColor: "#0d9488", color: "white", padding: "10px 20px", borderRadius: "8px", textDecoration: "none", fontSize: "14px", fontWeight: "600" }}>
                        Faire une demande de devis
                      </Link>
                    )}
                  </div>
                )}
              </div>
            )}
            {/* ── Import Site Web IA (exposant seulement) ── */}
            {activeTab === "import" && user.role === "exposant" && (
              <div>
                <h2 style={{ fontSize: isMobile ? "20px" : "24px", fontWeight: "700", color: "#1f2937", marginBottom: "8px" }}>🌐 Importer depuis votre site web</h2>
                <p style={{ color: "#6b7280", fontSize: "14px", marginBottom: "24px" }}>
                  Vous avez déjà un site ? Laissez l'IA analyser vos produits et créer vos annonces automatiquement sur MarinaDZ.
                </p>
                <div style={{ backgroundColor: "white", borderRadius: "12px", padding: "32px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", textAlign: "center" }}>
                  <div style={{ fontSize: "52px", marginBottom: "16px" }}>🤖</div>
                  <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#1f2937", marginBottom: "8px" }}>Import automatique par IA</h3>
                  <p style={{ fontSize: "13px", color: "#6b7280", marginBottom: "24px", maxWidth: "480px", margin: "0 auto 24px", lineHeight: "1.7" }}>
                    Collez l'URL de votre site — l'IA scrape le contenu, détecte vos produits et services,
                    et génère des annonces classifiées selon les catégories MarinaDZ. Vous validez avant publication.
                  </p>
                  <Link to="/import-site-web"
                    style={{ display: "inline-flex", alignItems: "center", gap: "8px", padding: "14px 32px", backgroundColor: "#0d9488", color: "white", borderRadius: "10px", textDecoration: "none", fontSize: "15px", fontWeight: "700" }}>
                    🌐 Démarrer l'import
                  </Link>
                </div>
              </div>
            )}

          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default MonEspace;